import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scale, Mail, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ClienteLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', senha: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/login`, formData);
      const { access_token, user_type, user_data } = response.data;

      if (user_type === 'cliente') {
        localStorage.setItem('token', access_token);
        localStorage.setItem('userType', user_type);
        localStorage.setItem('userData', JSON.stringify(user_data));
        toast.success('Login realizado com sucesso!');
        navigate('/cliente/dashboard');
      } else {
        toast.error('Credenciais inválidas para acesso de cliente');
      }
    } catch (error) {
      toast.error('Email ou senha incorretos');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen gradient-oxford flex items-center justify-center px-4">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-center pb-4">
          <div className="flex justify-center mb-4">
            <div className="bg-champagne p-4 rounded-full">
              <Scale className="w-12 h-12 text-oxford" />
            </div>
          </div>
          <CardTitle className="font-serif text-2xl text-oxford">
            Área do Cliente
          </CardTitle>
          <p className="text-gray-600 mt-2">Acompanhe seus processos</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-oxford font-semibold mb-2">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-3 w-5 h-5 text-gray-400" />
                <Input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                  placeholder="seuemail@exemplo.com"
                  className="pl-10 input-premium"
                  data-testid="cliente-email-input"
                />
              </div>
            </div>

            <div>
              <label className="block text-oxford font-semibold mb-2">Senha</label>
              <div className="relative">
                <Lock className="absolute left-3 top-3 w-5 h-5 text-gray-400" />
                <Input
                  type="password"
                  value={formData.senha}
                  onChange={(e) => setFormData({ ...formData, senha: e.target.value })}
                  required
                  placeholder="••••••••"
                  className="pl-10 input-premium"
                  data-testid="cliente-senha-input"
                />
              </div>
            </div>

            <Button 
              type="submit" 
              disabled={loading}
              className="btn-champagne w-full py-6 text-lg font-semibold"
              data-testid="cliente-login-btn"
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>

            <div className="text-center mt-4">
              <Button 
                type="button"
                variant="link" 
                onClick={() => navigate('/')}
                className="text-oxford hover:text-champagne"
              >
                Voltar para o site
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClienteLogin;
